/**
 * Wspólne komunikaty UI używane w stanach loading/success/error.
 * Trzymanie ich w jednym miejscu daje spójny język w całej aplikacji.
 */

// --- Loading ---
export const LOADING = "Ładowanie…";
export const LOADING_MAP = "Ładowanie mapy…";
export const LOADING_SLOW = "Ładowanie trwa dłużej niż zwykle…";
export const SUBMITTING = "Wysyłanie…";
export const SAVING = "Zapisywanie…";

// --- Actions / retry ---
export const RETRY = "Spróbuj ponownie";
export const TRY_AGAIN_LATER = "Spróbuj ponownie za chwilę.";

// --- Generic errors ---
export const GENERIC_ERROR_TITLE = "Coś poszło nie tak";
export const GENERIC_ERROR_DESC = "Sprawdź połączenie z internetem i spróbuj ponownie.";
export const GENERATE_FAILED = "Nie udało się wygenerować grafiki. Spróbuj ponownie.";
export const RATE_LIMITED = "Zbyt wiele zapytań. Spróbuj ponownie za chwilę.";

// --- Empty states ---
export const NO_RESULTS = "Brak wyników";
export const NO_INFO = "Brak informacji";
